import { defineStore } from 'pinia';
import { useHttp } from '@/http/http'; // 假設你有一個自定義的 HTTP 客戶端
import { reactive } from 'vue';
import { statusCheck } from '../public'; // 假設這是一個用來檢查 API 回應狀態的函數

export const useOverviewStore = defineStore('overview', {
  state: () => ({
    activeButton: 'This Month', // 初始化 state 中的 activeButton
    overviewInfo: {
      face_value: 0,
      face_value_diff_percent: 0,
      total_commission: 0,
      total_commission_diff_percent: 0,
      transaction_count: 0,
      transaction_count_diff_percent: 0,
      account_balance: 0,
      comparison_text: 'vs last month',
      month_face_value: {}
    }
  }),
  actions: {
    async fetchOverviewInfo(period = 'this_month', customStart = '', customEnd = '') {
      try {
        const response = await useHttp().get('/api/driver/overview/info', {
          params: {
            period,
            custom_start: customStart,
            custom_end: customEnd,
          },
        });

        // 假設 response.data.result 包含了我們需要的數據
        if (statusCheck(response.data)) {
          Object.assign(this.overviewInfo, response.data.result);
        } else {
          console.error('Failed to fetch overview info:', response.statusText);
        }
      } catch (error) {
        console.error('Error fetching overview info:', error);
      }
    },
    setActiveButton(button) {
      this.activeButton = button; // 更新 state 中的 activeButton
    }
  }
});
